module.exports = __webpack_public_path__ + "img/relevance.da509696.svg";